// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: nexus.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { ChartType, chartTypeFromJSON, chartTypeToJSON } from "./chart";
import {
  NotificationChannel,
  notificationChannelFromJSON,
  notificationChannelToJSON,
  Params,
  TimeBucket,
} from "./common";
import { Empty } from "./google/protobuf/empty";
import { StringValue } from "./google/protobuf/wrappers";
import { Filters } from "./screener";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.nexus";

export interface Expression {
  text: string;
  type: Expression_Type;
  security: Security[];
  isSpread: boolean;
  params: { [key: string]: string };
  timeBucket: TimeBucket | undefined;
}

export enum Expression_Type {
  VARIABLE_UNKNOWN = 0,
  PRICE = 1,
  VOLUME = 2,
  TECHNICAL_INDICATOR = 3,
  UNRECOGNIZED = -1,
}

export function expression_TypeFromJSON(object: any): Expression_Type {
  switch (object) {
    case 0:
    case "VARIABLE_UNKNOWN":
      return Expression_Type.VARIABLE_UNKNOWN;
    case 1:
    case "PRICE":
      return Expression_Type.PRICE;
    case 2:
    case "VOLUME":
      return Expression_Type.VOLUME;
    case 3:
    case "TECHNICAL_INDICATOR":
      return Expression_Type.TECHNICAL_INDICATOR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Expression_Type.UNRECOGNIZED;
  }
}

export function expression_TypeToJSON(object: Expression_Type): string {
  switch (object) {
    case Expression_Type.VARIABLE_UNKNOWN:
      return "VARIABLE_UNKNOWN";
    case Expression_Type.PRICE:
      return "PRICE";
    case Expression_Type.VOLUME:
      return "VOLUME";
    case Expression_Type.TECHNICAL_INDICATOR:
      return "TECHNICAL_INDICATOR";
    case Expression_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Expression_ParamsEntry {
  key: string;
  value: string;
}

export interface AlertDrawingPoint {
  timestamp: number;
  price: number;
}

export interface AlertDrawing {
  drawingType: string;
  drawingId: string;
  points: AlertDrawingPoint[];
  options: { [key: string]: string };
}

export interface AlertDrawing_OptionsEntry {
  key: string;
  value: string;
}

export interface AlertExpression {
  type: AlertExpression_Type;
  simpleSecurity?: SimpleSecurity | undefined;
  spreadSecurity?: SpreadSecurity | undefined;
  indicator?: AlertIndicator | undefined;
  fixedValue?: number | undefined;
  drawing?: AlertDrawing | undefined;
  timeBucket: TimeBucket | undefined;
}

export enum AlertExpression_Type {
  VARIABLE_UNKNOWN = 0,
  SIMPLE_SECURITY = 1,
  SPREAD_SECURITY = 2,
  TECHNICAL_INDICATOR = 3,
  FIXED_VALUE = 4,
  DRAWING = 5,
  UNRECOGNIZED = -1,
}

export function alertExpression_TypeFromJSON(object: any): AlertExpression_Type {
  switch (object) {
    case 0:
    case "VARIABLE_UNKNOWN":
      return AlertExpression_Type.VARIABLE_UNKNOWN;
    case 1:
    case "SIMPLE_SECURITY":
      return AlertExpression_Type.SIMPLE_SECURITY;
    case 2:
    case "SPREAD_SECURITY":
      return AlertExpression_Type.SPREAD_SECURITY;
    case 3:
    case "TECHNICAL_INDICATOR":
      return AlertExpression_Type.TECHNICAL_INDICATOR;
    case 4:
    case "FIXED_VALUE":
      return AlertExpression_Type.FIXED_VALUE;
    case 5:
    case "DRAWING":
      return AlertExpression_Type.DRAWING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AlertExpression_Type.UNRECOGNIZED;
  }
}

export function alertExpression_TypeToJSON(object: AlertExpression_Type): string {
  switch (object) {
    case AlertExpression_Type.VARIABLE_UNKNOWN:
      return "VARIABLE_UNKNOWN";
    case AlertExpression_Type.SIMPLE_SECURITY:
      return "SIMPLE_SECURITY";
    case AlertExpression_Type.SPREAD_SECURITY:
      return "SPREAD_SECURITY";
    case AlertExpression_Type.TECHNICAL_INDICATOR:
      return "TECHNICAL_INDICATOR";
    case AlertExpression_Type.FIXED_VALUE:
      return "FIXED_VALUE";
    case AlertExpression_Type.DRAWING:
      return "DRAWING";
    case AlertExpression_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Condition {
  timedAlertCondition?: Condition_TimedAlertCondition | undefined;
  securityAlertCondition?: Condition_SecurityAlertCondition | undefined;
  screenerAlertCondition?: Condition_ScreenerAlertCondition | undefined;
  compositeCondition?: Condition_CompositeCondition | undefined;
}

export interface Condition_SecurityAlertCondition {
  lhsExpression: AlertExpression | undefined;
  operator: Condition_SecurityAlertCondition_Operator;
  rhsExpression: AlertExpression | undefined;
}

export enum Condition_SecurityAlertCondition_Operator {
  OPERATOR_UNKNOWN = 0,
  EQUAL_TO = 1,
  GREATER_THAN = 2,
  LESS_THAN = 3,
  CROSSING_UP = 5,
  CROSSING_DOWN = 6,
  CROSSING = 7,
  UNRECOGNIZED = -1,
}

export function condition_SecurityAlertCondition_OperatorFromJSON(
  object: any,
): Condition_SecurityAlertCondition_Operator {
  switch (object) {
    case 0:
    case "OPERATOR_UNKNOWN":
      return Condition_SecurityAlertCondition_Operator.OPERATOR_UNKNOWN;
    case 1:
    case "EQUAL_TO":
      return Condition_SecurityAlertCondition_Operator.EQUAL_TO;
    case 2:
    case "GREATER_THAN":
      return Condition_SecurityAlertCondition_Operator.GREATER_THAN;
    case 3:
    case "LESS_THAN":
      return Condition_SecurityAlertCondition_Operator.LESS_THAN;
    case 5:
    case "CROSSING_UP":
      return Condition_SecurityAlertCondition_Operator.CROSSING_UP;
    case 6:
    case "CROSSING_DOWN":
      return Condition_SecurityAlertCondition_Operator.CROSSING_DOWN;
    case 7:
    case "CROSSING":
      return Condition_SecurityAlertCondition_Operator.CROSSING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Condition_SecurityAlertCondition_Operator.UNRECOGNIZED;
  }
}

export function condition_SecurityAlertCondition_OperatorToJSON(
  object: Condition_SecurityAlertCondition_Operator,
): string {
  switch (object) {
    case Condition_SecurityAlertCondition_Operator.OPERATOR_UNKNOWN:
      return "OPERATOR_UNKNOWN";
    case Condition_SecurityAlertCondition_Operator.EQUAL_TO:
      return "EQUAL_TO";
    case Condition_SecurityAlertCondition_Operator.GREATER_THAN:
      return "GREATER_THAN";
    case Condition_SecurityAlertCondition_Operator.LESS_THAN:
      return "LESS_THAN";
    case Condition_SecurityAlertCondition_Operator.CROSSING_UP:
      return "CROSSING_UP";
    case Condition_SecurityAlertCondition_Operator.CROSSING_DOWN:
      return "CROSSING_DOWN";
    case Condition_SecurityAlertCondition_Operator.CROSSING:
      return "CROSSING";
    case Condition_SecurityAlertCondition_Operator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Condition_TimedAlertCondition {
  timestamp: number;
}

export interface Condition_ScreenerAlertCondition {
  filters?: Filters | undefined;
  queryExpression?: string | undefined;
}

export interface Condition_CompositeCondition {
  condition: Condition[];
  logicalOperator: Condition_CompositeCondition_Operator;
}

export enum Condition_CompositeCondition_Operator {
  OPERATOR_UNKNOWN = 0,
  AND = 1,
  OR = 2,
  UNRECOGNIZED = -1,
}

export function condition_CompositeCondition_OperatorFromJSON(object: any): Condition_CompositeCondition_Operator {
  switch (object) {
    case 0:
    case "OPERATOR_UNKNOWN":
      return Condition_CompositeCondition_Operator.OPERATOR_UNKNOWN;
    case 1:
    case "AND":
      return Condition_CompositeCondition_Operator.AND;
    case 2:
    case "OR":
      return Condition_CompositeCondition_Operator.OR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Condition_CompositeCondition_Operator.UNRECOGNIZED;
  }
}

export function condition_CompositeCondition_OperatorToJSON(object: Condition_CompositeCondition_Operator): string {
  switch (object) {
    case Condition_CompositeCondition_Operator.OPERATOR_UNKNOWN:
      return "OPERATOR_UNKNOWN";
    case Condition_CompositeCondition_Operator.AND:
      return "AND";
    case Condition_CompositeCondition_Operator.OR:
      return "OR";
    case Condition_CompositeCondition_Operator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SimpleSecurity {
  security: Security | undefined;
  source: string;
}

export interface SpreadSecurity {
  security: Security[];
  source: string;
  spreadExpression: string;
}

export interface AlertIndicator {
  expression: AlertExpression | undefined;
  indicatorCode: string;
  params: Params[];
  output: string;
}

export interface UserAlertUpdateMessage {
  alertId: string;
  impactedNode: string[];
}

export interface UserAlert {
  id: string;
  name: string;
  message: string;
  userId: string;
  condition: Condition | undefined;
  timeBucket: TimeBucket | undefined;
  chartCandleType: ChartType;
  notificationChannels: NotificationChannel[];
  trigger: UserAlert_Trigger;
  lastTriggered: number;
  expiry: number;
  created: number;
  updated: number;
  status: UserAlert_Status;
  secondaryStatus: string;
  type: UserAlert_Type;
  category: UserAlert_Category;
  metadata: string;
  allocatedNodes: string[];
  security: Security | undefined;
}

export enum UserAlert_Category {
  CATEGORY_UNKNOWN = 0,
  USER_ALERT = 1,
  ORDER_ALERT = 2,
  PAPER_TRADING_ORDER_ALERT = 10,
  AUTOMATION_ALERT = 3,
  UNRECOGNIZED = -1,
}

export function userAlert_CategoryFromJSON(object: any): UserAlert_Category {
  switch (object) {
    case 0:
    case "CATEGORY_UNKNOWN":
      return UserAlert_Category.CATEGORY_UNKNOWN;
    case 1:
    case "USER_ALERT":
      return UserAlert_Category.USER_ALERT;
    case 2:
    case "ORDER_ALERT":
      return UserAlert_Category.ORDER_ALERT;
    case 10:
    case "PAPER_TRADING_ORDER_ALERT":
      return UserAlert_Category.PAPER_TRADING_ORDER_ALERT;
    case 3:
    case "AUTOMATION_ALERT":
      return UserAlert_Category.AUTOMATION_ALERT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserAlert_Category.UNRECOGNIZED;
  }
}

export function userAlert_CategoryToJSON(object: UserAlert_Category): string {
  switch (object) {
    case UserAlert_Category.CATEGORY_UNKNOWN:
      return "CATEGORY_UNKNOWN";
    case UserAlert_Category.USER_ALERT:
      return "USER_ALERT";
    case UserAlert_Category.ORDER_ALERT:
      return "ORDER_ALERT";
    case UserAlert_Category.PAPER_TRADING_ORDER_ALERT:
      return "PAPER_TRADING_ORDER_ALERT";
    case UserAlert_Category.AUTOMATION_ALERT:
      return "AUTOMATION_ALERT";
    case UserAlert_Category.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum UserAlert_Trigger {
  TRIGGER_UNKNOWN = 0,
  ONCE = 1,
  EVERYTIME = 2,
  ONCE_PER_BAR = 3,
  ONCE_PER_BAR_CLOSED = 4,
  ONCE_PER_MINUTE = 5,
  UNRECOGNIZED = -1,
}

export function userAlert_TriggerFromJSON(object: any): UserAlert_Trigger {
  switch (object) {
    case 0:
    case "TRIGGER_UNKNOWN":
      return UserAlert_Trigger.TRIGGER_UNKNOWN;
    case 1:
    case "ONCE":
      return UserAlert_Trigger.ONCE;
    case 2:
    case "EVERYTIME":
      return UserAlert_Trigger.EVERYTIME;
    case 3:
    case "ONCE_PER_BAR":
      return UserAlert_Trigger.ONCE_PER_BAR;
    case 4:
    case "ONCE_PER_BAR_CLOSED":
      return UserAlert_Trigger.ONCE_PER_BAR_CLOSED;
    case 5:
    case "ONCE_PER_MINUTE":
      return UserAlert_Trigger.ONCE_PER_MINUTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserAlert_Trigger.UNRECOGNIZED;
  }
}

export function userAlert_TriggerToJSON(object: UserAlert_Trigger): string {
  switch (object) {
    case UserAlert_Trigger.TRIGGER_UNKNOWN:
      return "TRIGGER_UNKNOWN";
    case UserAlert_Trigger.ONCE:
      return "ONCE";
    case UserAlert_Trigger.EVERYTIME:
      return "EVERYTIME";
    case UserAlert_Trigger.ONCE_PER_BAR:
      return "ONCE_PER_BAR";
    case UserAlert_Trigger.ONCE_PER_BAR_CLOSED:
      return "ONCE_PER_BAR_CLOSED";
    case UserAlert_Trigger.ONCE_PER_MINUTE:
      return "ONCE_PER_MINUTE";
    case UserAlert_Trigger.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum UserAlert_Type {
  ALERT_TYPE_UNKNOWN = 0,
  STANDARD = 1,
  SCREENER = 3,
  UNRECOGNIZED = -1,
}

export function userAlert_TypeFromJSON(object: any): UserAlert_Type {
  switch (object) {
    case 0:
    case "ALERT_TYPE_UNKNOWN":
      return UserAlert_Type.ALERT_TYPE_UNKNOWN;
    case 1:
    case "STANDARD":
      return UserAlert_Type.STANDARD;
    case 3:
    case "SCREENER":
      return UserAlert_Type.SCREENER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserAlert_Type.UNRECOGNIZED;
  }
}

export function userAlert_TypeToJSON(object: UserAlert_Type): string {
  switch (object) {
    case UserAlert_Type.ALERT_TYPE_UNKNOWN:
      return "ALERT_TYPE_UNKNOWN";
    case UserAlert_Type.STANDARD:
      return "STANDARD";
    case UserAlert_Type.SCREENER:
      return "SCREENER";
    case UserAlert_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum UserAlert_Status {
  ALERT_STATUS_UNKNOWN = 0,
  ACTIVE = 1,
  STOPPED = 3,
  DELETED = 4,
  INVALID = 5,
  UNRECOGNIZED = -1,
}

export function userAlert_StatusFromJSON(object: any): UserAlert_Status {
  switch (object) {
    case 0:
    case "ALERT_STATUS_UNKNOWN":
      return UserAlert_Status.ALERT_STATUS_UNKNOWN;
    case 1:
    case "ACTIVE":
      return UserAlert_Status.ACTIVE;
    case 3:
    case "STOPPED":
      return UserAlert_Status.STOPPED;
    case 4:
    case "DELETED":
      return UserAlert_Status.DELETED;
    case 5:
    case "INVALID":
      return UserAlert_Status.INVALID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserAlert_Status.UNRECOGNIZED;
  }
}

export function userAlert_StatusToJSON(object: UserAlert_Status): string {
  switch (object) {
    case UserAlert_Status.ALERT_STATUS_UNKNOWN:
      return "ALERT_STATUS_UNKNOWN";
    case UserAlert_Status.ACTIVE:
      return "ACTIVE";
    case UserAlert_Status.STOPPED:
      return "STOPPED";
    case UserAlert_Status.DELETED:
      return "DELETED";
    case UserAlert_Status.INVALID:
      return "INVALID";
    case UserAlert_Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetAllUserAlertsRequest {
  userId: string;
  pageNo: number;
  pageSize: number;
}

export interface GetAllUserAlertsResponse {
  alerts: UserAlert[];
  totalRows: number;
}

export interface GetSingleUserAlertRequest {
  userId: string;
  alertId: string;
}

export interface StopUserAlertRequest {
  userId: string;
  alertId: string;
}

export interface RestartUserAlertRequest {
  userId: string;
  alertId: string;
}

export interface RemoveUserAlertRequest {
  userId: string;
  alertId: string;
}

export interface RemoveUserAlertResponse {
}

export interface UserAlertLog {
  id: string;
  alertId: string;
  name: string;
  message: string;
  userId: string;
  triggeredTime: number;
  created: number;
  updated: number;
  alert: UserAlert | undefined;
  securities: Security[];
}

export interface GetAllUserAlertLogsRequest {
  userId: string;
  pageNo: number;
  pageSize: number;
}

export interface GetAllUserAlertLogsResponse {
  alertLogs: UserAlertLog[];
  totalRows: number;
}

export interface RemoveUserAlertLogRequest {
  userId: string;
  alertLogId: string;
}

export interface RemoveUserAlertLogResponse {
}

export interface RemoveAllUserAlertLogsRequest {
  userId: string;
}

export interface RemoveAllUserAlertLogsResponse {
}

function createBaseExpression(): Expression {
  return { text: "", type: 0, security: [], isSpread: false, params: {}, timeBucket: undefined };
}

export const Expression = {
  encode(message: Expression, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    for (const v of message.security) {
      Security.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.isSpread !== false) {
      writer.uint32(32).bool(message.isSpread);
    }
    Object.entries(message.params).forEach(([key, value]) => {
      Expression_ParamsEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).ldelim();
    });
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Expression {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExpression();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.security.push(Security.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isSpread = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          const entry5 = Expression_ParamsEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.params[entry5.key] = entry5.value;
          }
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Expression {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      type: isSet(object.type) ? expression_TypeFromJSON(object.type) : 0,
      security: globalThis.Array.isArray(object?.security) ? object.security.map((e: any) => Security.fromJSON(e)) : [],
      isSpread: isSet(object.isSpread) ? globalThis.Boolean(object.isSpread) : false,
      params: isObject(object.params)
        ? Object.entries(object.params).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
    };
  },

  toJSON(message: Expression): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.type !== 0) {
      obj.type = expression_TypeToJSON(message.type);
    }
    if (message.security?.length) {
      obj.security = message.security.map((e) => Security.toJSON(e));
    }
    if (message.isSpread !== false) {
      obj.isSpread = message.isSpread;
    }
    if (message.params) {
      const entries = Object.entries(message.params);
      if (entries.length > 0) {
        obj.params = {};
        entries.forEach(([k, v]) => {
          obj.params[k] = v;
        });
      }
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Expression>, I>>(base?: I): Expression {
    return Expression.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Expression>, I>>(object: I): Expression {
    const message = createBaseExpression();
    message.text = object.text ?? "";
    message.type = object.type ?? 0;
    message.security = object.security?.map((e) => Security.fromPartial(e)) || [];
    message.isSpread = object.isSpread ?? false;
    message.params = Object.entries(object.params ?? {}).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value);
      }
      return acc;
    }, {});
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    return message;
  },
};

function createBaseExpression_ParamsEntry(): Expression_ParamsEntry {
  return { key: "", value: "" };
}

export const Expression_ParamsEntry = {
  encode(message: Expression_ParamsEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Expression_ParamsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExpression_ParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Expression_ParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: Expression_ParamsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Expression_ParamsEntry>, I>>(base?: I): Expression_ParamsEntry {
    return Expression_ParamsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Expression_ParamsEntry>, I>>(object: I): Expression_ParamsEntry {
    const message = createBaseExpression_ParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseAlertDrawingPoint(): AlertDrawingPoint {
  return { timestamp: 0, price: 0 };
}

export const AlertDrawingPoint = {
  encode(message: AlertDrawingPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timestamp !== 0) {
      writer.uint32(8).int64(message.timestamp);
    }
    if (message.price !== 0) {
      writer.uint32(17).double(message.price);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AlertDrawingPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlertDrawingPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.timestamp = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.price = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AlertDrawingPoint {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
    };
  },

  toJSON(message: AlertDrawingPoint): unknown {
    const obj: any = {};
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.price !== 0) {
      obj.price = message.price;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertDrawingPoint>, I>>(base?: I): AlertDrawingPoint {
    return AlertDrawingPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertDrawingPoint>, I>>(object: I): AlertDrawingPoint {
    const message = createBaseAlertDrawingPoint();
    message.timestamp = object.timestamp ?? 0;
    message.price = object.price ?? 0;
    return message;
  },
};

function createBaseAlertDrawing(): AlertDrawing {
  return { drawingType: "", drawingId: "", points: [], options: {} };
}

export const AlertDrawing = {
  encode(message: AlertDrawing, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.drawingType !== "") {
      writer.uint32(10).string(message.drawingType);
    }
    if (message.drawingId !== "") {
      writer.uint32(18).string(message.drawingId);
    }
    for (const v of message.points) {
      AlertDrawingPoint.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    Object.entries(message.options).forEach(([key, value]) => {
      AlertDrawing_OptionsEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AlertDrawing {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlertDrawing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.drawingType = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.drawingId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.points.push(AlertDrawingPoint.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          const entry4 = AlertDrawing_OptionsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.options[entry4.key] = entry4.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AlertDrawing {
    return {
      drawingType: isSet(object.drawingType) ? globalThis.String(object.drawingType) : "",
      drawingId: isSet(object.drawingId) ? globalThis.String(object.drawingId) : "",
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => AlertDrawingPoint.fromJSON(e))
        : [],
      options: isObject(object.options)
        ? Object.entries(object.options).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: AlertDrawing): unknown {
    const obj: any = {};
    if (message.drawingType !== "") {
      obj.drawingType = message.drawingType;
    }
    if (message.drawingId !== "") {
      obj.drawingId = message.drawingId;
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => AlertDrawingPoint.toJSON(e));
    }
    if (message.options) {
      const entries = Object.entries(message.options);
      if (entries.length > 0) {
        obj.options = {};
        entries.forEach(([k, v]) => {
          obj.options[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertDrawing>, I>>(base?: I): AlertDrawing {
    return AlertDrawing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertDrawing>, I>>(object: I): AlertDrawing {
    const message = createBaseAlertDrawing();
    message.drawingType = object.drawingType ?? "";
    message.drawingId = object.drawingId ?? "";
    message.points = object.points?.map((e) => AlertDrawingPoint.fromPartial(e)) || [];
    message.options = Object.entries(object.options ?? {}).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseAlertDrawing_OptionsEntry(): AlertDrawing_OptionsEntry {
  return { key: "", value: "" };
}

export const AlertDrawing_OptionsEntry = {
  encode(message: AlertDrawing_OptionsEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AlertDrawing_OptionsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlertDrawing_OptionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AlertDrawing_OptionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: AlertDrawing_OptionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertDrawing_OptionsEntry>, I>>(base?: I): AlertDrawing_OptionsEntry {
    return AlertDrawing_OptionsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertDrawing_OptionsEntry>, I>>(object: I): AlertDrawing_OptionsEntry {
    const message = createBaseAlertDrawing_OptionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseAlertExpression(): AlertExpression {
  return {
    type: 0,
    simpleSecurity: undefined,
    spreadSecurity: undefined,
    indicator: undefined,
    fixedValue: undefined,
    drawing: undefined,
    timeBucket: undefined,
  };
}

export const AlertExpression = {
  encode(message: AlertExpression, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.simpleSecurity !== undefined) {
      SimpleSecurity.encode(message.simpleSecurity, writer.uint32(82).fork()).ldelim();
    }
    if (message.spreadSecurity !== undefined) {
      SpreadSecurity.encode(message.spreadSecurity, writer.uint32(90).fork()).ldelim();
    }
    if (message.indicator !== undefined) {
      AlertIndicator.encode(message.indicator, writer.uint32(98).fork()).ldelim();
    }
    if (message.fixedValue !== undefined) {
      writer.uint32(105).double(message.fixedValue);
    }
    if (message.drawing !== undefined) {
      AlertDrawing.encode(message.drawing, writer.uint32(114).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(130).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AlertExpression {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlertExpression();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.simpleSecurity = SimpleSecurity.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.spreadSecurity = SpreadSecurity.decode(reader, reader.uint32());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.indicator = AlertIndicator.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 105) {
            break;
          }

          message.fixedValue = reader.double();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.drawing = AlertDrawing.decode(reader, reader.uint32());
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AlertExpression {
    return {
      type: isSet(object.type) ? alertExpression_TypeFromJSON(object.type) : 0,
      simpleSecurity: isSet(object.simpleSecurity) ? SimpleSecurity.fromJSON(object.simpleSecurity) : undefined,
      spreadSecurity: isSet(object.spreadSecurity) ? SpreadSecurity.fromJSON(object.spreadSecurity) : undefined,
      indicator: isSet(object.indicator) ? AlertIndicator.fromJSON(object.indicator) : undefined,
      fixedValue: isSet(object.fixedValue) ? globalThis.Number(object.fixedValue) : undefined,
      drawing: isSet(object.drawing) ? AlertDrawing.fromJSON(object.drawing) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
    };
  },

  toJSON(message: AlertExpression): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = alertExpression_TypeToJSON(message.type);
    }
    if (message.simpleSecurity !== undefined) {
      obj.simpleSecurity = SimpleSecurity.toJSON(message.simpleSecurity);
    }
    if (message.spreadSecurity !== undefined) {
      obj.spreadSecurity = SpreadSecurity.toJSON(message.spreadSecurity);
    }
    if (message.indicator !== undefined) {
      obj.indicator = AlertIndicator.toJSON(message.indicator);
    }
    if (message.fixedValue !== undefined) {
      obj.fixedValue = message.fixedValue;
    }
    if (message.drawing !== undefined) {
      obj.drawing = AlertDrawing.toJSON(message.drawing);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertExpression>, I>>(base?: I): AlertExpression {
    return AlertExpression.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertExpression>, I>>(object: I): AlertExpression {
    const message = createBaseAlertExpression();
    message.type = object.type ?? 0;
    message.simpleSecurity = (object.simpleSecurity !== undefined && object.simpleSecurity !== null)
      ? SimpleSecurity.fromPartial(object.simpleSecurity)
      : undefined;
    message.spreadSecurity = (object.spreadSecurity !== undefined && object.spreadSecurity !== null)
      ? SpreadSecurity.fromPartial(object.spreadSecurity)
      : undefined;
    message.indicator = (object.indicator !== undefined && object.indicator !== null)
      ? AlertIndicator.fromPartial(object.indicator)
      : undefined;
    message.fixedValue = object.fixedValue ?? undefined;
    message.drawing = (object.drawing !== undefined && object.drawing !== null)
      ? AlertDrawing.fromPartial(object.drawing)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    return message;
  },
};

function createBaseCondition(): Condition {
  return {
    timedAlertCondition: undefined,
    securityAlertCondition: undefined,
    screenerAlertCondition: undefined,
    compositeCondition: undefined,
  };
}

export const Condition = {
  encode(message: Condition, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timedAlertCondition !== undefined) {
      Condition_TimedAlertCondition.encode(message.timedAlertCondition, writer.uint32(42).fork()).ldelim();
    }
    if (message.securityAlertCondition !== undefined) {
      Condition_SecurityAlertCondition.encode(message.securityAlertCondition, writer.uint32(10).fork()).ldelim();
    }
    if (message.screenerAlertCondition !== undefined) {
      Condition_ScreenerAlertCondition.encode(message.screenerAlertCondition, writer.uint32(18).fork()).ldelim();
    }
    if (message.compositeCondition !== undefined) {
      Condition_CompositeCondition.encode(message.compositeCondition, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Condition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 5:
          if (tag !== 42) {
            break;
          }

          message.timedAlertCondition = Condition_TimedAlertCondition.decode(reader, reader.uint32());
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securityAlertCondition = Condition_SecurityAlertCondition.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.screenerAlertCondition = Condition_ScreenerAlertCondition.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.compositeCondition = Condition_CompositeCondition.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Condition {
    return {
      timedAlertCondition: isSet(object.timedAlertCondition)
        ? Condition_TimedAlertCondition.fromJSON(object.timedAlertCondition)
        : undefined,
      securityAlertCondition: isSet(object.securityAlertCondition)
        ? Condition_SecurityAlertCondition.fromJSON(object.securityAlertCondition)
        : undefined,
      screenerAlertCondition: isSet(object.screenerAlertCondition)
        ? Condition_ScreenerAlertCondition.fromJSON(object.screenerAlertCondition)
        : undefined,
      compositeCondition: isSet(object.compositeCondition)
        ? Condition_CompositeCondition.fromJSON(object.compositeCondition)
        : undefined,
    };
  },

  toJSON(message: Condition): unknown {
    const obj: any = {};
    if (message.timedAlertCondition !== undefined) {
      obj.timedAlertCondition = Condition_TimedAlertCondition.toJSON(message.timedAlertCondition);
    }
    if (message.securityAlertCondition !== undefined) {
      obj.securityAlertCondition = Condition_SecurityAlertCondition.toJSON(message.securityAlertCondition);
    }
    if (message.screenerAlertCondition !== undefined) {
      obj.screenerAlertCondition = Condition_ScreenerAlertCondition.toJSON(message.screenerAlertCondition);
    }
    if (message.compositeCondition !== undefined) {
      obj.compositeCondition = Condition_CompositeCondition.toJSON(message.compositeCondition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Condition>, I>>(base?: I): Condition {
    return Condition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Condition>, I>>(object: I): Condition {
    const message = createBaseCondition();
    message.timedAlertCondition = (object.timedAlertCondition !== undefined && object.timedAlertCondition !== null)
      ? Condition_TimedAlertCondition.fromPartial(object.timedAlertCondition)
      : undefined;
    message.securityAlertCondition =
      (object.securityAlertCondition !== undefined && object.securityAlertCondition !== null)
        ? Condition_SecurityAlertCondition.fromPartial(object.securityAlertCondition)
        : undefined;
    message.screenerAlertCondition =
      (object.screenerAlertCondition !== undefined && object.screenerAlertCondition !== null)
        ? Condition_ScreenerAlertCondition.fromPartial(object.screenerAlertCondition)
        : undefined;
    message.compositeCondition = (object.compositeCondition !== undefined && object.compositeCondition !== null)
      ? Condition_CompositeCondition.fromPartial(object.compositeCondition)
      : undefined;
    return message;
  },
};

function createBaseCondition_SecurityAlertCondition(): Condition_SecurityAlertCondition {
  return { lhsExpression: undefined, operator: 0, rhsExpression: undefined };
}

export const Condition_SecurityAlertCondition = {
  encode(message: Condition_SecurityAlertCondition, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.lhsExpression !== undefined) {
      AlertExpression.encode(message.lhsExpression, writer.uint32(10).fork()).ldelim();
    }
    if (message.operator !== 0) {
      writer.uint32(32).int32(message.operator);
    }
    if (message.rhsExpression !== undefined) {
      AlertExpression.encode(message.rhsExpression, writer.uint32(82).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Condition_SecurityAlertCondition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCondition_SecurityAlertCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.lhsExpression = AlertExpression.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.operator = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.rhsExpression = AlertExpression.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Condition_SecurityAlertCondition {
    return {
      lhsExpression: isSet(object.lhsExpression) ? AlertExpression.fromJSON(object.lhsExpression) : undefined,
      operator: isSet(object.operator) ? condition_SecurityAlertCondition_OperatorFromJSON(object.operator) : 0,
      rhsExpression: isSet(object.rhsExpression) ? AlertExpression.fromJSON(object.rhsExpression) : undefined,
    };
  },

  toJSON(message: Condition_SecurityAlertCondition): unknown {
    const obj: any = {};
    if (message.lhsExpression !== undefined) {
      obj.lhsExpression = AlertExpression.toJSON(message.lhsExpression);
    }
    if (message.operator !== 0) {
      obj.operator = condition_SecurityAlertCondition_OperatorToJSON(message.operator);
    }
    if (message.rhsExpression !== undefined) {
      obj.rhsExpression = AlertExpression.toJSON(message.rhsExpression);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Condition_SecurityAlertCondition>, I>>(
    base?: I,
  ): Condition_SecurityAlertCondition {
    return Condition_SecurityAlertCondition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Condition_SecurityAlertCondition>, I>>(
    object: I,
  ): Condition_SecurityAlertCondition {
    const message = createBaseCondition_SecurityAlertCondition();
    message.lhsExpression = (object.lhsExpression !== undefined && object.lhsExpression !== null)
      ? AlertExpression.fromPartial(object.lhsExpression)
      : undefined;
    message.operator = object.operator ?? 0;
    message.rhsExpression = (object.rhsExpression !== undefined && object.rhsExpression !== null)
      ? AlertExpression.fromPartial(object.rhsExpression)
      : undefined;
    return message;
  },
};

function createBaseCondition_TimedAlertCondition(): Condition_TimedAlertCondition {
  return { timestamp: 0 };
}

export const Condition_TimedAlertCondition = {
  encode(message: Condition_TimedAlertCondition, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timestamp !== 0) {
      writer.uint32(8).int64(message.timestamp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Condition_TimedAlertCondition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCondition_TimedAlertCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.timestamp = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Condition_TimedAlertCondition {
    return { timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0 };
  },

  toJSON(message: Condition_TimedAlertCondition): unknown {
    const obj: any = {};
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Condition_TimedAlertCondition>, I>>(base?: I): Condition_TimedAlertCondition {
    return Condition_TimedAlertCondition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Condition_TimedAlertCondition>, I>>(
    object: I,
  ): Condition_TimedAlertCondition {
    const message = createBaseCondition_TimedAlertCondition();
    message.timestamp = object.timestamp ?? 0;
    return message;
  },
};

function createBaseCondition_ScreenerAlertCondition(): Condition_ScreenerAlertCondition {
  return { filters: undefined, queryExpression: undefined };
}

export const Condition_ScreenerAlertCondition = {
  encode(message: Condition_ScreenerAlertCondition, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.filters !== undefined) {
      Filters.encode(message.filters, writer.uint32(10).fork()).ldelim();
    }
    if (message.queryExpression !== undefined) {
      writer.uint32(18).string(message.queryExpression);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Condition_ScreenerAlertCondition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCondition_ScreenerAlertCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.filters = Filters.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.queryExpression = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Condition_ScreenerAlertCondition {
    return {
      filters: isSet(object.filters) ? Filters.fromJSON(object.filters) : undefined,
      queryExpression: isSet(object.queryExpression) ? globalThis.String(object.queryExpression) : undefined,
    };
  },

  toJSON(message: Condition_ScreenerAlertCondition): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = Filters.toJSON(message.filters);
    }
    if (message.queryExpression !== undefined) {
      obj.queryExpression = message.queryExpression;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Condition_ScreenerAlertCondition>, I>>(
    base?: I,
  ): Condition_ScreenerAlertCondition {
    return Condition_ScreenerAlertCondition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Condition_ScreenerAlertCondition>, I>>(
    object: I,
  ): Condition_ScreenerAlertCondition {
    const message = createBaseCondition_ScreenerAlertCondition();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? Filters.fromPartial(object.filters)
      : undefined;
    message.queryExpression = object.queryExpression ?? undefined;
    return message;
  },
};

function createBaseCondition_CompositeCondition(): Condition_CompositeCondition {
  return { condition: [], logicalOperator: 0 };
}

export const Condition_CompositeCondition = {
  encode(message: Condition_CompositeCondition, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.condition) {
      Condition.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.logicalOperator !== 0) {
      writer.uint32(16).int32(message.logicalOperator);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Condition_CompositeCondition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCondition_CompositeCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.condition.push(Condition.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.logicalOperator = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Condition_CompositeCondition {
    return {
      condition: globalThis.Array.isArray(object?.condition)
        ? object.condition.map((e: any) => Condition.fromJSON(e))
        : [],
      logicalOperator: isSet(object.logicalOperator)
        ? condition_CompositeCondition_OperatorFromJSON(object.logicalOperator)
        : 0,
    };
  },

  toJSON(message: Condition_CompositeCondition): unknown {
    const obj: any = {};
    if (message.condition?.length) {
      obj.condition = message.condition.map((e) => Condition.toJSON(e));
    }
    if (message.logicalOperator !== 0) {
      obj.logicalOperator = condition_CompositeCondition_OperatorToJSON(message.logicalOperator);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Condition_CompositeCondition>, I>>(base?: I): Condition_CompositeCondition {
    return Condition_CompositeCondition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Condition_CompositeCondition>, I>>(object: I): Condition_CompositeCondition {
    const message = createBaseCondition_CompositeCondition();
    message.condition = object.condition?.map((e) => Condition.fromPartial(e)) || [];
    message.logicalOperator = object.logicalOperator ?? 0;
    return message;
  },
};

function createBaseSimpleSecurity(): SimpleSecurity {
  return { security: undefined, source: "" };
}

export const SimpleSecurity = {
  encode(message: SimpleSecurity, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(26).fork()).ldelim();
    }
    if (message.source !== "") {
      writer.uint32(34).string(message.source);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimpleSecurity {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimpleSecurity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          if (tag !== 26) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.source = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimpleSecurity {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      source: isSet(object.source) ? globalThis.String(object.source) : "",
    };
  },

  toJSON(message: SimpleSecurity): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.source !== "") {
      obj.source = message.source;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimpleSecurity>, I>>(base?: I): SimpleSecurity {
    return SimpleSecurity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimpleSecurity>, I>>(object: I): SimpleSecurity {
    const message = createBaseSimpleSecurity();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.source = object.source ?? "";
    return message;
  },
};

function createBaseSpreadSecurity(): SpreadSecurity {
  return { security: [], source: "", spreadExpression: "" };
}

export const SpreadSecurity = {
  encode(message: SpreadSecurity, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.security) {
      Security.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.source !== "") {
      writer.uint32(34).string(message.source);
    }
    if (message.spreadExpression !== "") {
      writer.uint32(42).string(message.spreadExpression);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpreadSecurity {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpreadSecurity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          if (tag !== 26) {
            break;
          }

          message.security.push(Security.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.source = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.spreadExpression = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpreadSecurity {
    return {
      security: globalThis.Array.isArray(object?.security) ? object.security.map((e: any) => Security.fromJSON(e)) : [],
      source: isSet(object.source) ? globalThis.String(object.source) : "",
      spreadExpression: isSet(object.spreadExpression) ? globalThis.String(object.spreadExpression) : "",
    };
  },

  toJSON(message: SpreadSecurity): unknown {
    const obj: any = {};
    if (message.security?.length) {
      obj.security = message.security.map((e) => Security.toJSON(e));
    }
    if (message.source !== "") {
      obj.source = message.source;
    }
    if (message.spreadExpression !== "") {
      obj.spreadExpression = message.spreadExpression;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpreadSecurity>, I>>(base?: I): SpreadSecurity {
    return SpreadSecurity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpreadSecurity>, I>>(object: I): SpreadSecurity {
    const message = createBaseSpreadSecurity();
    message.security = object.security?.map((e) => Security.fromPartial(e)) || [];
    message.source = object.source ?? "";
    message.spreadExpression = object.spreadExpression ?? "";
    return message;
  },
};

function createBaseAlertIndicator(): AlertIndicator {
  return { expression: undefined, indicatorCode: "", params: [], output: "" };
}

export const AlertIndicator = {
  encode(message: AlertIndicator, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.expression !== undefined) {
      AlertExpression.encode(message.expression, writer.uint32(10).fork()).ldelim();
    }
    if (message.indicatorCode !== "") {
      writer.uint32(58).string(message.indicatorCode);
    }
    for (const v of message.params) {
      Params.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    if (message.output !== "") {
      writer.uint32(74).string(message.output);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AlertIndicator {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlertIndicator();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.expression = AlertExpression.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.indicatorCode = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.params.push(Params.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.output = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AlertIndicator {
    return {
      expression: isSet(object.expression) ? AlertExpression.fromJSON(object.expression) : undefined,
      indicatorCode: isSet(object.indicatorCode) ? globalThis.String(object.indicatorCode) : "",
      params: globalThis.Array.isArray(object?.params) ? object.params.map((e: any) => Params.fromJSON(e)) : [],
      output: isSet(object.output) ? globalThis.String(object.output) : "",
    };
  },

  toJSON(message: AlertIndicator): unknown {
    const obj: any = {};
    if (message.expression !== undefined) {
      obj.expression = AlertExpression.toJSON(message.expression);
    }
    if (message.indicatorCode !== "") {
      obj.indicatorCode = message.indicatorCode;
    }
    if (message.params?.length) {
      obj.params = message.params.map((e) => Params.toJSON(e));
    }
    if (message.output !== "") {
      obj.output = message.output;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertIndicator>, I>>(base?: I): AlertIndicator {
    return AlertIndicator.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertIndicator>, I>>(object: I): AlertIndicator {
    const message = createBaseAlertIndicator();
    message.expression = (object.expression !== undefined && object.expression !== null)
      ? AlertExpression.fromPartial(object.expression)
      : undefined;
    message.indicatorCode = object.indicatorCode ?? "";
    message.params = object.params?.map((e) => Params.fromPartial(e)) || [];
    message.output = object.output ?? "";
    return message;
  },
};

function createBaseUserAlertUpdateMessage(): UserAlertUpdateMessage {
  return { alertId: "", impactedNode: [] };
}

export const UserAlertUpdateMessage = {
  encode(message: UserAlertUpdateMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.alertId !== "") {
      writer.uint32(10).string(message.alertId);
    }
    for (const v of message.impactedNode) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserAlertUpdateMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserAlertUpdateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.alertId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.impactedNode.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserAlertUpdateMessage {
    return {
      alertId: isSet(object.alertId) ? globalThis.String(object.alertId) : "",
      impactedNode: globalThis.Array.isArray(object?.impactedNode)
        ? object.impactedNode.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: UserAlertUpdateMessage): unknown {
    const obj: any = {};
    if (message.alertId !== "") {
      obj.alertId = message.alertId;
    }
    if (message.impactedNode?.length) {
      obj.impactedNode = message.impactedNode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserAlertUpdateMessage>, I>>(base?: I): UserAlertUpdateMessage {
    return UserAlertUpdateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserAlertUpdateMessage>, I>>(object: I): UserAlertUpdateMessage {
    const message = createBaseUserAlertUpdateMessage();
    message.alertId = object.alertId ?? "";
    message.impactedNode = object.impactedNode?.map((e) => e) || [];
    return message;
  },
};

function createBaseUserAlert(): UserAlert {
  return {
    id: "",
    name: "",
    message: "",
    userId: "",
    condition: undefined,
    timeBucket: undefined,
    chartCandleType: 0,
    notificationChannels: [],
    trigger: 0,
    lastTriggered: 0,
    expiry: 0,
    created: 0,
    updated: 0,
    status: 0,
    secondaryStatus: "",
    type: 0,
    category: 0,
    metadata: "",
    allocatedNodes: [],
    security: undefined,
  };
}

export const UserAlert = {
  encode(message: UserAlert, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    if (message.userId !== "") {
      writer.uint32(34).string(message.userId);
    }
    if (message.condition !== undefined) {
      Condition.encode(message.condition, writer.uint32(42).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(50).fork()).ldelim();
    }
    if (message.chartCandleType !== 0) {
      writer.uint32(280).int32(message.chartCandleType);
    }
    writer.uint32(58).fork();
    for (const v of message.notificationChannels) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.trigger !== 0) {
      writer.uint32(64).int32(message.trigger);
    }
    if (message.lastTriggered !== 0) {
      writer.uint32(72).int64(message.lastTriggered);
    }
    if (message.expiry !== 0) {
      writer.uint32(80).int64(message.expiry);
    }
    if (message.created !== 0) {
      writer.uint32(88).int64(message.created);
    }
    if (message.updated !== 0) {
      writer.uint32(96).int64(message.updated);
    }
    if (message.status !== 0) {
      writer.uint32(104).int32(message.status);
    }
    if (message.secondaryStatus !== "") {
      writer.uint32(122).string(message.secondaryStatus);
    }
    if (message.type !== 0) {
      writer.uint32(128).int32(message.type);
    }
    if (message.category !== 0) {
      writer.uint32(160).int32(message.category);
    }
    if (message.metadata !== "") {
      writer.uint32(138).string(message.metadata);
    }
    for (const v of message.allocatedNodes) {
      writer.uint32(146).string(v!);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(154).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserAlert {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserAlert();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.condition = Condition.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 35:
          if (tag !== 280) {
            break;
          }

          message.chartCandleType = reader.int32() as any;
          continue;
        case 7:
          if (tag === 56) {
            message.notificationChannels.push(reader.int32() as any);

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.notificationChannels.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.trigger = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.lastTriggered = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.expiry = longToNumber(reader.int64() as Long);
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.created = longToNumber(reader.int64() as Long);
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.updated = longToNumber(reader.int64() as Long);
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.secondaryStatus = reader.string();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.metadata = reader.string();
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.allocatedNodes.push(reader.string());
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserAlert {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      condition: isSet(object.condition) ? Condition.fromJSON(object.condition) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      chartCandleType: isSet(object.chartCandleType) ? chartTypeFromJSON(object.chartCandleType) : 0,
      notificationChannels: globalThis.Array.isArray(object?.notificationChannels)
        ? object.notificationChannels.map((e: any) => notificationChannelFromJSON(e))
        : [],
      trigger: isSet(object.trigger) ? userAlert_TriggerFromJSON(object.trigger) : 0,
      lastTriggered: isSet(object.lastTriggered) ? globalThis.Number(object.lastTriggered) : 0,
      expiry: isSet(object.expiry) ? globalThis.Number(object.expiry) : 0,
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      updated: isSet(object.updated) ? globalThis.Number(object.updated) : 0,
      status: isSet(object.status) ? userAlert_StatusFromJSON(object.status) : 0,
      secondaryStatus: isSet(object.secondaryStatus) ? globalThis.String(object.secondaryStatus) : "",
      type: isSet(object.type) ? userAlert_TypeFromJSON(object.type) : 0,
      category: isSet(object.category) ? userAlert_CategoryFromJSON(object.category) : 0,
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : "",
      allocatedNodes: globalThis.Array.isArray(object?.allocatedNodes)
        ? object.allocatedNodes.map((e: any) => globalThis.String(e))
        : [],
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
    };
  },

  toJSON(message: UserAlert): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.condition !== undefined) {
      obj.condition = Condition.toJSON(message.condition);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.chartCandleType !== 0) {
      obj.chartCandleType = chartTypeToJSON(message.chartCandleType);
    }
    if (message.notificationChannels?.length) {
      obj.notificationChannels = message.notificationChannels.map((e) => notificationChannelToJSON(e));
    }
    if (message.trigger !== 0) {
      obj.trigger = userAlert_TriggerToJSON(message.trigger);
    }
    if (message.lastTriggered !== 0) {
      obj.lastTriggered = Math.round(message.lastTriggered);
    }
    if (message.expiry !== 0) {
      obj.expiry = Math.round(message.expiry);
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.updated !== 0) {
      obj.updated = Math.round(message.updated);
    }
    if (message.status !== 0) {
      obj.status = userAlert_StatusToJSON(message.status);
    }
    if (message.secondaryStatus !== "") {
      obj.secondaryStatus = message.secondaryStatus;
    }
    if (message.type !== 0) {
      obj.type = userAlert_TypeToJSON(message.type);
    }
    if (message.category !== 0) {
      obj.category = userAlert_CategoryToJSON(message.category);
    }
    if (message.metadata !== "") {
      obj.metadata = message.metadata;
    }
    if (message.allocatedNodes?.length) {
      obj.allocatedNodes = message.allocatedNodes;
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserAlert>, I>>(base?: I): UserAlert {
    return UserAlert.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserAlert>, I>>(object: I): UserAlert {
    const message = createBaseUserAlert();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.message = object.message ?? "";
    message.userId = object.userId ?? "";
    message.condition = (object.condition !== undefined && object.condition !== null)
      ? Condition.fromPartial(object.condition)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.chartCandleType = object.chartCandleType ?? 0;
    message.notificationChannels = object.notificationChannels?.map((e) => e) || [];
    message.trigger = object.trigger ?? 0;
    message.lastTriggered = object.lastTriggered ?? 0;
    message.expiry = object.expiry ?? 0;
    message.created = object.created ?? 0;
    message.updated = object.updated ?? 0;
    message.status = object.status ?? 0;
    message.secondaryStatus = object.secondaryStatus ?? "";
    message.type = object.type ?? 0;
    message.category = object.category ?? 0;
    message.metadata = object.metadata ?? "";
    message.allocatedNodes = object.allocatedNodes?.map((e) => e) || [];
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    return message;
  },
};

function createBaseGetAllUserAlertsRequest(): GetAllUserAlertsRequest {
  return { userId: "", pageNo: 0, pageSize: 0 };
}

export const GetAllUserAlertsRequest = {
  encode(message: GetAllUserAlertsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.pageNo !== 0) {
      writer.uint32(16).int32(message.pageNo);
    }
    if (message.pageSize !== 0) {
      writer.uint32(24).int32(message.pageSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAllUserAlertsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllUserAlertsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.pageNo = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllUserAlertsRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      pageNo: isSet(object.pageNo) ? globalThis.Number(object.pageNo) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
    };
  },

  toJSON(message: GetAllUserAlertsRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.pageNo !== 0) {
      obj.pageNo = Math.round(message.pageNo);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllUserAlertsRequest>, I>>(base?: I): GetAllUserAlertsRequest {
    return GetAllUserAlertsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllUserAlertsRequest>, I>>(object: I): GetAllUserAlertsRequest {
    const message = createBaseGetAllUserAlertsRequest();
    message.userId = object.userId ?? "";
    message.pageNo = object.pageNo ?? 0;
    message.pageSize = object.pageSize ?? 0;
    return message;
  },
};

function createBaseGetAllUserAlertsResponse(): GetAllUserAlertsResponse {
  return { alerts: [], totalRows: 0 };
}

export const GetAllUserAlertsResponse = {
  encode(message: GetAllUserAlertsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.alerts) {
      UserAlert.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.totalRows !== 0) {
      writer.uint32(16).int32(message.totalRows);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAllUserAlertsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllUserAlertsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.alerts.push(UserAlert.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalRows = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllUserAlertsResponse {
    return {
      alerts: globalThis.Array.isArray(object?.alerts) ? object.alerts.map((e: any) => UserAlert.fromJSON(e)) : [],
      totalRows: isSet(object.totalRows) ? globalThis.Number(object.totalRows) : 0,
    };
  },

  toJSON(message: GetAllUserAlertsResponse): unknown {
    const obj: any = {};
    if (message.alerts?.length) {
      obj.alerts = message.alerts.map((e) => UserAlert.toJSON(e));
    }
    if (message.totalRows !== 0) {
      obj.totalRows = Math.round(message.totalRows);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllUserAlertsResponse>, I>>(base?: I): GetAllUserAlertsResponse {
    return GetAllUserAlertsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllUserAlertsResponse>, I>>(object: I): GetAllUserAlertsResponse {
    const message = createBaseGetAllUserAlertsResponse();
    message.alerts = object.alerts?.map((e) => UserAlert.fromPartial(e)) || [];
    message.totalRows = object.totalRows ?? 0;
    return message;
  },
};

function createBaseGetSingleUserAlertRequest(): GetSingleUserAlertRequest {
  return { userId: "", alertId: "" };
}

export const GetSingleUserAlertRequest = {
  encode(message: GetSingleUserAlertRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.alertId !== "") {
      writer.uint32(18).string(message.alertId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetSingleUserAlertRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSingleUserAlertRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.alertId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSingleUserAlertRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      alertId: isSet(object.alertId) ? globalThis.String(object.alertId) : "",
    };
  },

  toJSON(message: GetSingleUserAlertRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.alertId !== "") {
      obj.alertId = message.alertId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSingleUserAlertRequest>, I>>(base?: I): GetSingleUserAlertRequest {
    return GetSingleUserAlertRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSingleUserAlertRequest>, I>>(object: I): GetSingleUserAlertRequest {
    const message = createBaseGetSingleUserAlertRequest();
    message.userId = object.userId ?? "";
    message.alertId = object.alertId ?? "";
    return message;
  },
};

function createBaseStopUserAlertRequest(): StopUserAlertRequest {
  return { userId: "", alertId: "" };
}

export const StopUserAlertRequest = {
  encode(message: StopUserAlertRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.alertId !== "") {
      writer.uint32(18).string(message.alertId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopUserAlertRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopUserAlertRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.alertId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopUserAlertRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      alertId: isSet(object.alertId) ? globalThis.String(object.alertId) : "",
    };
  },

  toJSON(message: StopUserAlertRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.alertId !== "") {
      obj.alertId = message.alertId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopUserAlertRequest>, I>>(base?: I): StopUserAlertRequest {
    return StopUserAlertRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopUserAlertRequest>, I>>(object: I): StopUserAlertRequest {
    const message = createBaseStopUserAlertRequest();
    message.userId = object.userId ?? "";
    message.alertId = object.alertId ?? "";
    return message;
  },
};

function createBaseRestartUserAlertRequest(): RestartUserAlertRequest {
  return { userId: "", alertId: "" };
}

export const RestartUserAlertRequest = {
  encode(message: RestartUserAlertRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.alertId !== "") {
      writer.uint32(18).string(message.alertId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RestartUserAlertRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestartUserAlertRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.alertId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestartUserAlertRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      alertId: isSet(object.alertId) ? globalThis.String(object.alertId) : "",
    };
  },

  toJSON(message: RestartUserAlertRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.alertId !== "") {
      obj.alertId = message.alertId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestartUserAlertRequest>, I>>(base?: I): RestartUserAlertRequest {
    return RestartUserAlertRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestartUserAlertRequest>, I>>(object: I): RestartUserAlertRequest {
    const message = createBaseRestartUserAlertRequest();
    message.userId = object.userId ?? "";
    message.alertId = object.alertId ?? "";
    return message;
  },
};

function createBaseRemoveUserAlertRequest(): RemoveUserAlertRequest {
  return { userId: "", alertId: "" };
}

export const RemoveUserAlertRequest = {
  encode(message: RemoveUserAlertRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.alertId !== "") {
      writer.uint32(18).string(message.alertId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveUserAlertRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveUserAlertRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.alertId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveUserAlertRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      alertId: isSet(object.alertId) ? globalThis.String(object.alertId) : "",
    };
  },

  toJSON(message: RemoveUserAlertRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.alertId !== "") {
      obj.alertId = message.alertId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveUserAlertRequest>, I>>(base?: I): RemoveUserAlertRequest {
    return RemoveUserAlertRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveUserAlertRequest>, I>>(object: I): RemoveUserAlertRequest {
    const message = createBaseRemoveUserAlertRequest();
    message.userId = object.userId ?? "";
    message.alertId = object.alertId ?? "";
    return message;
  },
};

function createBaseRemoveUserAlertResponse(): RemoveUserAlertResponse {
  return {};
}

export const RemoveUserAlertResponse = {
  encode(_: RemoveUserAlertResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveUserAlertResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveUserAlertResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RemoveUserAlertResponse {
    return {};
  },

  toJSON(_: RemoveUserAlertResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveUserAlertResponse>, I>>(base?: I): RemoveUserAlertResponse {
    return RemoveUserAlertResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveUserAlertResponse>, I>>(_: I): RemoveUserAlertResponse {
    const message = createBaseRemoveUserAlertResponse();
    return message;
  },
};

function createBaseUserAlertLog(): UserAlertLog {
  return {
    id: "",
    alertId: "",
    name: "",
    message: "",
    userId: "",
    triggeredTime: 0,
    created: 0,
    updated: 0,
    alert: undefined,
    securities: [],
  };
}

export const UserAlertLog = {
  encode(message: UserAlertLog, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.alertId !== "") {
      writer.uint32(18).string(message.alertId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.message !== "") {
      writer.uint32(34).string(message.message);
    }
    if (message.userId !== "") {
      writer.uint32(58).string(message.userId);
    }
    if (message.triggeredTime !== 0) {
      writer.uint32(64).int64(message.triggeredTime);
    }
    if (message.created !== 0) {
      writer.uint32(72).int64(message.created);
    }
    if (message.updated !== 0) {
      writer.uint32(80).int64(message.updated);
    }
    if (message.alert !== undefined) {
      UserAlert.encode(message.alert, writer.uint32(90).fork()).ldelim();
    }
    for (const v of message.securities) {
      Security.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserAlertLog {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserAlertLog();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.alertId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.message = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.triggeredTime = longToNumber(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.created = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.updated = longToNumber(reader.int64() as Long);
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.alert = UserAlert.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.securities.push(Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserAlertLog {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      alertId: isSet(object.alertId) ? globalThis.String(object.alertId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      triggeredTime: isSet(object.triggeredTime) ? globalThis.Number(object.triggeredTime) : 0,
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      updated: isSet(object.updated) ? globalThis.Number(object.updated) : 0,
      alert: isSet(object.alert) ? UserAlert.fromJSON(object.alert) : undefined,
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserAlertLog): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.alertId !== "") {
      obj.alertId = message.alertId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.triggeredTime !== 0) {
      obj.triggeredTime = Math.round(message.triggeredTime);
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.updated !== 0) {
      obj.updated = Math.round(message.updated);
    }
    if (message.alert !== undefined) {
      obj.alert = UserAlert.toJSON(message.alert);
    }
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserAlertLog>, I>>(base?: I): UserAlertLog {
    return UserAlertLog.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserAlertLog>, I>>(object: I): UserAlertLog {
    const message = createBaseUserAlertLog();
    message.id = object.id ?? "";
    message.alertId = object.alertId ?? "";
    message.name = object.name ?? "";
    message.message = object.message ?? "";
    message.userId = object.userId ?? "";
    message.triggeredTime = object.triggeredTime ?? 0;
    message.created = object.created ?? 0;
    message.updated = object.updated ?? 0;
    message.alert = (object.alert !== undefined && object.alert !== null)
      ? UserAlert.fromPartial(object.alert)
      : undefined;
    message.securities = object.securities?.map((e) => Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetAllUserAlertLogsRequest(): GetAllUserAlertLogsRequest {
  return { userId: "", pageNo: 0, pageSize: 0 };
}

export const GetAllUserAlertLogsRequest = {
  encode(message: GetAllUserAlertLogsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.pageNo !== 0) {
      writer.uint32(16).int32(message.pageNo);
    }
    if (message.pageSize !== 0) {
      writer.uint32(24).int32(message.pageSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAllUserAlertLogsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllUserAlertLogsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.pageNo = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllUserAlertLogsRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      pageNo: isSet(object.pageNo) ? globalThis.Number(object.pageNo) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
    };
  },

  toJSON(message: GetAllUserAlertLogsRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.pageNo !== 0) {
      obj.pageNo = Math.round(message.pageNo);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllUserAlertLogsRequest>, I>>(base?: I): GetAllUserAlertLogsRequest {
    return GetAllUserAlertLogsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllUserAlertLogsRequest>, I>>(object: I): GetAllUserAlertLogsRequest {
    const message = createBaseGetAllUserAlertLogsRequest();
    message.userId = object.userId ?? "";
    message.pageNo = object.pageNo ?? 0;
    message.pageSize = object.pageSize ?? 0;
    return message;
  },
};

function createBaseGetAllUserAlertLogsResponse(): GetAllUserAlertLogsResponse {
  return { alertLogs: [], totalRows: 0 };
}

export const GetAllUserAlertLogsResponse = {
  encode(message: GetAllUserAlertLogsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.alertLogs) {
      UserAlertLog.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.totalRows !== 0) {
      writer.uint32(16).int32(message.totalRows);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAllUserAlertLogsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllUserAlertLogsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.alertLogs.push(UserAlertLog.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalRows = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllUserAlertLogsResponse {
    return {
      alertLogs: globalThis.Array.isArray(object?.alertLogs)
        ? object.alertLogs.map((e: any) => UserAlertLog.fromJSON(e))
        : [],
      totalRows: isSet(object.totalRows) ? globalThis.Number(object.totalRows) : 0,
    };
  },

  toJSON(message: GetAllUserAlertLogsResponse): unknown {
    const obj: any = {};
    if (message.alertLogs?.length) {
      obj.alertLogs = message.alertLogs.map((e) => UserAlertLog.toJSON(e));
    }
    if (message.totalRows !== 0) {
      obj.totalRows = Math.round(message.totalRows);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllUserAlertLogsResponse>, I>>(base?: I): GetAllUserAlertLogsResponse {
    return GetAllUserAlertLogsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllUserAlertLogsResponse>, I>>(object: I): GetAllUserAlertLogsResponse {
    const message = createBaseGetAllUserAlertLogsResponse();
    message.alertLogs = object.alertLogs?.map((e) => UserAlertLog.fromPartial(e)) || [];
    message.totalRows = object.totalRows ?? 0;
    return message;
  },
};

function createBaseRemoveUserAlertLogRequest(): RemoveUserAlertLogRequest {
  return { userId: "", alertLogId: "" };
}

export const RemoveUserAlertLogRequest = {
  encode(message: RemoveUserAlertLogRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.alertLogId !== "") {
      writer.uint32(18).string(message.alertLogId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveUserAlertLogRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveUserAlertLogRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.alertLogId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveUserAlertLogRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      alertLogId: isSet(object.alertLogId) ? globalThis.String(object.alertLogId) : "",
    };
  },

  toJSON(message: RemoveUserAlertLogRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.alertLogId !== "") {
      obj.alertLogId = message.alertLogId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveUserAlertLogRequest>, I>>(base?: I): RemoveUserAlertLogRequest {
    return RemoveUserAlertLogRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveUserAlertLogRequest>, I>>(object: I): RemoveUserAlertLogRequest {
    const message = createBaseRemoveUserAlertLogRequest();
    message.userId = object.userId ?? "";
    message.alertLogId = object.alertLogId ?? "";
    return message;
  },
};

function createBaseRemoveUserAlertLogResponse(): RemoveUserAlertLogResponse {
  return {};
}

export const RemoveUserAlertLogResponse = {
  encode(_: RemoveUserAlertLogResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveUserAlertLogResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveUserAlertLogResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RemoveUserAlertLogResponse {
    return {};
  },

  toJSON(_: RemoveUserAlertLogResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveUserAlertLogResponse>, I>>(base?: I): RemoveUserAlertLogResponse {
    return RemoveUserAlertLogResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveUserAlertLogResponse>, I>>(_: I): RemoveUserAlertLogResponse {
    const message = createBaseRemoveUserAlertLogResponse();
    return message;
  },
};

function createBaseRemoveAllUserAlertLogsRequest(): RemoveAllUserAlertLogsRequest {
  return { userId: "" };
}

export const RemoveAllUserAlertLogsRequest = {
  encode(message: RemoveAllUserAlertLogsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveAllUserAlertLogsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveAllUserAlertLogsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveAllUserAlertLogsRequest {
    return { userId: isSet(object.userId) ? globalThis.String(object.userId) : "" };
  },

  toJSON(message: RemoveAllUserAlertLogsRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveAllUserAlertLogsRequest>, I>>(base?: I): RemoveAllUserAlertLogsRequest {
    return RemoveAllUserAlertLogsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveAllUserAlertLogsRequest>, I>>(
    object: I,
  ): RemoveAllUserAlertLogsRequest {
    const message = createBaseRemoveAllUserAlertLogsRequest();
    message.userId = object.userId ?? "";
    return message;
  },
};

function createBaseRemoveAllUserAlertLogsResponse(): RemoveAllUserAlertLogsResponse {
  return {};
}

export const RemoveAllUserAlertLogsResponse = {
  encode(_: RemoveAllUserAlertLogsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveAllUserAlertLogsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveAllUserAlertLogsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RemoveAllUserAlertLogsResponse {
    return {};
  },

  toJSON(_: RemoveAllUserAlertLogsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveAllUserAlertLogsResponse>, I>>(base?: I): RemoveAllUserAlertLogsResponse {
    return RemoveAllUserAlertLogsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveAllUserAlertLogsResponse>, I>>(_: I): RemoveAllUserAlertLogsResponse {
    const message = createBaseRemoveAllUserAlertLogsResponse();
    return message;
  },
};

export interface AlertService {
  CreateUserAlert(request: UserAlert): Promise<UserAlert>;
  GetSingleUserAlert(request: GetSingleUserAlertRequest): Promise<UserAlert>;
  GetAllUserAlerts(request: GetAllUserAlertsRequest): Promise<GetAllUserAlertsResponse>;
  StopUserAlert(request: StopUserAlertRequest): Promise<UserAlert>;
  RestartUserAlert(request: RestartUserAlertRequest): Promise<UserAlert>;
  RemoveUserAlert(request: RemoveUserAlertRequest): Promise<RemoveUserAlertResponse>;
}

export const AlertServiceServiceName = "com.tick2trade.api.nexus.AlertService";
export class AlertServiceClientImpl implements AlertService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || AlertServiceServiceName;
    this.rpc = rpc;
    this.CreateUserAlert = this.CreateUserAlert.bind(this);
    this.GetSingleUserAlert = this.GetSingleUserAlert.bind(this);
    this.GetAllUserAlerts = this.GetAllUserAlerts.bind(this);
    this.StopUserAlert = this.StopUserAlert.bind(this);
    this.RestartUserAlert = this.RestartUserAlert.bind(this);
    this.RemoveUserAlert = this.RemoveUserAlert.bind(this);
  }
  CreateUserAlert(request: UserAlert): Promise<UserAlert> {
    const data = UserAlert.encode(request).finish();
    const promise = this.rpc.request(this.service, "CreateUserAlert", data);
    return promise.then((data) => UserAlert.decode(_m0.Reader.create(data)));
  }

  GetSingleUserAlert(request: GetSingleUserAlertRequest): Promise<UserAlert> {
    const data = GetSingleUserAlertRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetSingleUserAlert", data);
    return promise.then((data) => UserAlert.decode(_m0.Reader.create(data)));
  }

  GetAllUserAlerts(request: GetAllUserAlertsRequest): Promise<GetAllUserAlertsResponse> {
    const data = GetAllUserAlertsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetAllUserAlerts", data);
    return promise.then((data) => GetAllUserAlertsResponse.decode(_m0.Reader.create(data)));
  }

  StopUserAlert(request: StopUserAlertRequest): Promise<UserAlert> {
    const data = StopUserAlertRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "StopUserAlert", data);
    return promise.then((data) => UserAlert.decode(_m0.Reader.create(data)));
  }

  RestartUserAlert(request: RestartUserAlertRequest): Promise<UserAlert> {
    const data = RestartUserAlertRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RestartUserAlert", data);
    return promise.then((data) => UserAlert.decode(_m0.Reader.create(data)));
  }

  RemoveUserAlert(request: RemoveUserAlertRequest): Promise<RemoveUserAlertResponse> {
    const data = RemoveUserAlertRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveUserAlert", data);
    return promise.then((data) => RemoveUserAlertResponse.decode(_m0.Reader.create(data)));
  }
}

export interface UserAlertLogService {
  GetAllUserAlertLogs(request: GetAllUserAlertLogsRequest): Promise<GetAllUserAlertLogsResponse>;
  RemoveUserAlertLog(request: RemoveUserAlertLogRequest): Promise<RemoveUserAlertLogResponse>;
  RemoveAllUserAlertLogs(request: RemoveAllUserAlertLogsRequest): Promise<RemoveAllUserAlertLogsResponse>;
}

export const UserAlertLogServiceServiceName = "com.tick2trade.api.nexus.UserAlertLogService";
export class UserAlertLogServiceClientImpl implements UserAlertLogService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || UserAlertLogServiceServiceName;
    this.rpc = rpc;
    this.GetAllUserAlertLogs = this.GetAllUserAlertLogs.bind(this);
    this.RemoveUserAlertLog = this.RemoveUserAlertLog.bind(this);
    this.RemoveAllUserAlertLogs = this.RemoveAllUserAlertLogs.bind(this);
  }
  GetAllUserAlertLogs(request: GetAllUserAlertLogsRequest): Promise<GetAllUserAlertLogsResponse> {
    const data = GetAllUserAlertLogsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetAllUserAlertLogs", data);
    return promise.then((data) => GetAllUserAlertLogsResponse.decode(_m0.Reader.create(data)));
  }

  RemoveUserAlertLog(request: RemoveUserAlertLogRequest): Promise<RemoveUserAlertLogResponse> {
    const data = RemoveUserAlertLogRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveUserAlertLog", data);
    return promise.then((data) => RemoveUserAlertLogResponse.decode(_m0.Reader.create(data)));
  }

  RemoveAllUserAlertLogs(request: RemoveAllUserAlertLogsRequest): Promise<RemoveAllUserAlertLogsResponse> {
    const data = RemoveAllUserAlertLogsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveAllUserAlertLogs", data);
    return promise.then((data) => RemoveAllUserAlertLogsResponse.decode(_m0.Reader.create(data)));
  }
}

export interface NexusUserHandlingService {
  PurgeUserData(request: StringValue): Promise<Empty>;
}

export const NexusUserHandlingServiceServiceName = "com.tick2trade.api.nexus.NexusUserHandlingService";
export class NexusUserHandlingServiceClientImpl implements NexusUserHandlingService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || NexusUserHandlingServiceServiceName;
    this.rpc = rpc;
    this.PurgeUserData = this.PurgeUserData.bind(this);
  }
  PurgeUserData(request: StringValue): Promise<Empty> {
    const data = StringValue.encode(request).finish();
    const promise = this.rpc.request(this.service, "PurgeUserData", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
